import React from "react";
import { FormattedMessage } from "react-intl";
import "../theme/washPackagePrices.css";
import washPackagesJSON from "../data/washPackages.json";

const WashPackagePrices = () => {
  const washPackagesHTML = washPackagesJSON.map(washPackage => {
    const { id, name, price, payout, cut } = washPackage;

    return (
      <tr key={`package_${id}`}>
        <td>{name}</td>
        <td>{price}</td>
        <td>{payout}</td>
        <td>{cut}</td>
      </tr>
    );
  });

  return (
    <table className="tablePricing" cellSpacing="0">
      <thead>
        <tr>
          <th>
            <FormattedMessage id="WashPackagePrices.Package" />
          </th>
          <th>
            <FormattedMessage id="WashPackagePrices.CustomerPrice" />
          </th>
          <th>
            <FormattedMessage id="WashPackagePrices.YourPayout" />
          </th>
          <th>
            <FormattedMessage id="WashPackagePrices.OurFee" />
          </th>
        </tr>
      </thead>
      <tbody>{washPackagesHTML}</tbody>
    </table>
  );
};

export default WashPackagePrices;



// WEBPACK FOOTER //
// ./src/components/WashPackagePrices.js